module.exports = __webpack_public_path__ + "static/media/screenBackground11.daee6f3c.jpg";